import { ModalContent } from '@/components/Modal'

import { useConfigureController } from '../hooks/useController'
import { Body } from './Body'
import { Header } from './Header'
import { Footer } from './Footer'
import { InvalidBody } from './InvalidBody'
import { useControllerActions } from '../hooks/useControllerActions'

type Props = {
  orderStepIds: string[]
}

export function Content(props: Props) {
  const { ready, invalid } = useConfigureController(props.orderStepIds)
  const actions = useControllerActions()

  if (!ready) return null

  return (
    <ModalContent
      customCloseModal={actions.cancelAndCloseTryCloseTransaction}
      header={<Header />}
      footer={<Footer />}
    >
      {invalid ? <InvalidBody /> : <Body />}
    </ModalContent>
  )
}
